const unboundReasons = document.querySelectorAll('.why-unbound__reason');

const arrowAnimate = function() {
  const arrow = document.querySelector('.why-unbound__arrow');

  unboundReasons.forEach(reason => {
    if (reason.classList.contains('active')) {
      const reasonHeight = parseInt(getComputedStyle(reason).height);
      arrowTopPosition = reason.offsetTop === 0 ? `${reasonHeight / 2}px` : `${reason.offsetTop + (reasonHeight / 2)}px`
      arrow.style.top = arrowTopPosition;

      if(arrow.classList.contains('hidden')) arrow.classList.remove('hidden');
    }
  })
}

const imageUpdate = function(reason) {
  // 1- Reset
  document.querySelectorAll('.why-unbound__image--desktop .image-container').forEach(img => img.classList.remove('active'));

  // 2- Show active image
  document.querySelector(reason.getAttribute('data-image')).classList.add('active');
}

// On load
arrowAnimate();

// On Resize
window.addEventListener('resize', function() {arrowAnimate()});

// On Mouse Hover
unboundReasons.forEach(reason => {
  reason.addEventListener('mouseenter', function(e) {

    if (!reason.classList.contains('active')) {
      // 1- Reset
      unboundReasons.forEach(el => {el.classList.remove('active')});

      // 2- Add active class
      reason.classList.add('active');

      // 3- Arrow animate
      arrowAnimate();
      
      // 5- Image Update
      imageUpdate(reason);
    }
  })
});